import { Component, Inject, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import CaptchetatService from './captchetat.service';

@Component
export default class CaptchetatWidget extends Vue {
  @Inject('captchetatService') private captchetatService: () => CaptchetatService;

  @Prop({ default: 'captchaFR' }) public captchaType: string;

  public captchaUuid: string = '';
  public captchaImageb64: string = '';
  public captchaCode: string = '';
  public loading: boolean = false;
  public error: string = '';
  public validated: boolean = false;

  public mounted() {
    this.generateCaptcha();
  }

  public generateCaptcha() {
    this.loading = true;
    this.error = '';
    this.validated = false;
    this.captchaCode = '';
    this.captchetatService()
      .generate(this.captchaType)
      .then(
        res => {
          this.captchaUuid = res.data.uuid;
          this.captchaImageb64 = res.data.imageb64;
          this.loading = false;
        },
        err => {
          this.error = 'Erreur lors du chargement du captcha';
          this.loading = false;
        }
      );
  }

  public handleValidate() {
    if (!this.captchaCode.trim()) {
      return;
    }
    this.loading = true;
    this.error = '';
    this.captchetatService()
      .validate(this.captchaUuid, this.captchaCode)
      .then(
        res => {
          this.loading = false;
          if (res.data === true) {
            this.validated = true;
            this.$emit('validated', true);
          } else {
            this.validated = false;
            this.error = 'Code incorrect, veuillez réessayer';
            this.$emit('validated', false);
            this.generateCaptcha();
          }
        },
        err => {
          this.loading = false;
          this.error = 'Erreur lors de la validation du captcha';
          this.$emit('validated', false);
        }
      );
  }

  public refreshCaptcha() {
    this.validated = false;
    this.$emit('validated', false);
    this.generateCaptcha();
  }

  public onInputCode(value: string) {
    this.captchaCode = value;
  }
}
